import React, { useEffect, useState } from "react";
import eventBus from "src/utils/eventBus";

const PdfImageModal: React.FC = () => {
    const [images, setImages] = useState<any>(null);
    const [isVisible, setIsVisible] = useState(false);
    const [isHandlingBack, setIsHandlingBack] = useState(false);

    useEffect(() => {
            const onShowPdf = (data: { images }) => {
                setImages(data.images);
                setTimeout(() => setIsVisible(true), 10);
                if (window.history.state !== "modal-open") {
                    window.history.pushState("modal-open", "", window.location.pathname);
                }
        };

        eventBus.on("pdfImageModal:show", onShowPdf);

        return () => {
            eventBus.off("pdfImageModal:show", onShowPdf);
        };
    }, []);

    useEffect(() => {
        if (isVisible) {
            document.body.style.overflow = "hidden";

            const handleBackButton = () => {
                if (!isVisible || isHandlingBack) return;

                setIsHandlingBack(true);
                closeModal();

                setTimeout(() => setIsHandlingBack(false), 200);
            };

            window.addEventListener("popstate", handleBackButton);

            return () => {
                setTimeout(() => {
                    document.body.style.overflow = "auto";
                }, 150);
                window.removeEventListener("popstate", handleBackButton);
                setIsHandlingBack(false);
            };
        }
    }, [isVisible, isHandlingBack]);

    const closeModal = () => {
        setIsVisible(false); 
        setTimeout(() => setImages(null), 300);
    };

    if (!images) return null;

    return (
        <>
            <div className={`overlay ${isVisible ? "active" : ""}`} onClick={closeModal}></div>
            <div className={`modal fade ${isVisible ? "show" : ""} d-block`} tabIndex={-1}>
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content text-center">
                        <div className="modal-header border-0 px-4">
                            <button 
                                type="button" 
                                className="btn-close" 
                                onClick={closeModal}
                            >
                            </button>
                        </div>
                        <div className="modal-body text-center">
                            {images.map((image: string, index: number) => (
                                <img key={index} className="image-item" src={image} alt="" />
                            ))}
                            <button type="button" className="btn btn-light w-100 pt-3 pb-3" onClick={closeModal}>확인</button>
                        </div>
                    </div>
                </div>
            </div>

            <style>{`
                .modal {
                    display: flex !important;
                    justify-content: center;                    
                    background: rgba(0, 0, 0, 0.8);
                    z-index: 1050;
                }
                .modal-dialog {
                    display: inline-block; 
                    width: auto;
                    max-width: none;
                }

                .modal-content {
                    max-width: unset;
                    background: white;
                    border-radius: 8px;
                    display: inline-block;
                }

                .modal-body {
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    padding: 20px;
                }

                .image-item {
                    display: block;
                    height: auto;
                    max-width: 100%;
                }
                    
                @media (max-width: 768px) {
                    .modal-dialog {
                        width: 100vmin !important;
                        height: 100vmax !important;
                        max-width: 100vw;
                        max-height: 100vh;
                        margin: 0;
                    }

                    .modal-content {
                        width: 100%;
                        height: 100%;
                        border-radius: 0;
                    }

                    .modal-body {
                        flex-grow: 1;
                        width: 100%;
                        max-height: calc(100vh - 120px);
                        height: 100%;
                        overflow-y: auto;
                    }

                    .image-item {
                        width: 100%;
                        height: auto;
                        object-fit: contain;
                    }
                }
            `}</style>
        </>
    );
};

export default PdfImageModal;
